import { theme } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectPeople } from 'reduxStore/people/selectors';
import { PersonProfileImage } from 'zComponents/atoms';
import LockersPersonDrawer from 'zComponents/molecules/LockersPersonDrawer';
import PersonDrawer from 'zComponents/molecules/PersonDrawer';
import { Button, Col, Empty, Flex, Row, Typography } from 'zui/Antd';

const { Text } = Typography;

const RenderPeoplePanelContent = ({ searchResults = [], isSearching = false }) => {
	const {
		token: {
			colorTextLabel,
			fontWeightStrong,
			padding,
			borderRadius,
			paddingSM,
			colorFill,
			colorPrimaryText,
			lineHeight,
			lineHeightLG,
			fontSizeLG
		}
	} = theme.useToken();
	const {
		dashboard: { selected }
	} = useSelector((state) => state.App);
	const allPeopleData = useSelector(selectPeople);

	const [openDrawer, setOpenDrawer] = useState(false);
	const [selectedPerson, setSelectedPerson] = useState(null);
	const displayData = isSearching ? searchResults.map((result) => result.item) : allPeopleData;

	if (displayData.length === 0) {
		return (
			<Flex align='center' justify='center' vertical style={{ width: '100%', padding }}>
				<Empty description={isSearching ? 'No search results found' : 'No people to display'} />
			</Flex>
		);
	}

	return (
		<Row gutter={[20, 20]} justify='start'>
			{displayData.map((person, index) => (
				<Col key={isSearching ? `search-${index}` : index} xl={8} lg={12} sm={24}>
					<Flex
						vertical
						style={{
							border: `1px solid ${colorFill}`,
							padding: paddingSM,
							borderRadius,
							boxSizing: 'border-box'
						}}
					>
						<Flex align='center' justify='space-between'>
							<Flex gap={12} flex={1} style={{ width: 0 }}>
								<PersonProfileImage
									size={44}
									photoUrl={person.photoUrl || undefined}
									name={person?.displayName}
									entityName='People'
									shape='circle'
									edit={false}
								/>

								<Flex vertical style={{ minWidth: 0, flex: 1 }}>
									<Text
										ellipsis={{ tooltip: person?.displayName }}
										style={{
											width: '100%',
											color: colorTextLabel,
											fontWeight: fontWeightStrong,
											fontSize: fontSizeLG,
											lineHeight: lineHeightLG
										}}
									>
										{person?.displayName || '--'}
									</Text>
									<Text
										ellipsis={{ tooltip: person?.email }}
										style={{
											width: '100%',
											color: colorTextLabel,
											fontWeight: 500,
											lineHeight: lineHeight
										}}
									>
										{person?.email || '--'}
									</Text>
								</Flex>
							</Flex>
							<Button
								onClick={() => {
									setSelectedPerson(person?.personID);
									setOpenDrawer(true);
								}}
								type='text'
								style={{ color: colorPrimaryText }}
							>
								View Person
							</Button>
						</Flex>
					</Flex>
				</Col>
			))}
			{selected === 'lockers' ? (
				<LockersPersonDrawer personID={selectedPerson} visible={openDrawer} setVisible={setOpenDrawer} />
			) : (
				<PersonDrawer personID={selectedPerson} visible={openDrawer} setVisible={setOpenDrawer} />
			)}
		</Row>
	);
};

export default RenderPeoplePanelContent;
